// @flow
import { openDialog } from '../../../base/dialog/actions';
import { isLocalParticipantModerator } from '../../../base/participants';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { getEnabledSaveCaption } from '../../functions';
import DialogSaveCaption from './DialogSaveCaption';
/**
 * The button component which starts/stops the transcription.
 */
export class AbstractSaveCaptionButton extends AbstractButton {
    /**
     * Handles clicking / pressing the button.
     *
     * @override
     * @protected
     * @returns {void}
     */
    async _handleClick() {
        const { dispatch, isLocalModerator } = this.props;
        if (isLocalModerator) {
            let liveCaptionSaveStatus = 2;
            webSocket.emit("enable_save_live_caption_client", liveCaptionSaveStatus);
            webSocket.once("enable_save_live_caption_server", (data) => {
                liveCaptionSaveStatus = data;
                dispatch(openDialog(DialogSaveCaption, {
                    liveCaptionSaveStatus
                }));
            });
        }
    }
    /**
     * Indicates whether this button is disabled or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isDisabled() {
        return false;
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props.saveCaptionEnabled;
    }
}
/**
 * Maps (parts of) the redux state to the associated props for the
 * {@code AbstractClosedCaptionButton} component.
 *
 * @param {Object} state - The redux state.
 * @param {Object} ownProps - The properties explicitly passed to the component
 * instance.
 * @private
 * @returns {{
 *     _requestingSubtitles: boolean,
 *     visible: boolean
 * }}
 */
export function _abstractMapStateToProps(state) {
    const isLocalModerator = isLocalParticipantModerator(state);
    const saveCaptionEnabled = getEnabledSaveCaption(state);
    return {
        isLocalModerator,
        saveCaptionEnabled,
        customClass: 'guild-save-caption',
        customId: 'save-caption-id'
    };
}
